import React, {Component, Fragment} from 'react';
import Modal from 'react-modal';
import CsodFormWraper from "../Csod/CsodFormWraper";
import CsodFormFieldWraper from "../Csod/CsodFormFieldWraper";
import {getFormField} from "../../helpers/widgetHelpers";
import FontAwesome from 'react-fontawesome'

class FormNewTrigger extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newTriggerFormShow: false
        };
        this.onClose = this.onClose.bind(this);
    }

    getFormFields() {
        return [
            {
                title: "Trigger Title",
                type: "text"
            },
            {
                title: "Date",
                type: "datePicker",
            },
            {
                title: "Offset",
                type: "select",
                options: [
                    {
                        label: "None",
                        value: "None"
                    },
                    {
                        label: "Before",
                        value: "Before"
                    },
                    {
                        label: "After",
                        value: "After"
                    },
                ]
            },
            {
                title: "Offset days",
                type: "text"
            },
            {
                title: "Occur every n time",
                type: "text"
            },
            {
                title: "Send To (User/Relationship)",
                type: "text"
            },
            {
                title: "Cc (User/Relationship)",
                type: "text"
            },
            {
                title: "Availability (OUs/Groups)",
                type: "text"
            },
            {
                title: "Subject",
                type: "text"
            },
            {
                title: "Message (WYSIWYG)",
                type: "wysiwyg"
            }
        ];
    }

    onClose() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {

        const formFields = this.getFormFields();
        return (
            <Fragment>
                <Modal
                    isOpen={true}
                    onRequestClose={this.onClose}>
                    <div className="cso-txtr cso-cont-pad10tb sc-btn-grp">
                        <button className={"modal-close"} onClick={this.onClose}><FontAwesome name={"times"}/></button>
                    </div>
                    <table className="Panel_title" role="presentation"
                           cellSpacing="0" cellPadding="0">
                        <tbody>
                        <tr>
                            <td></td>
                            <td><h1>Create New Trigger</h1></td>
                            <td></td>
                        </tr>
                        </tbody>
                    </table>

                    <CsodFormWraper onClose={this.onClose}>
                        {formFields.map((field, index) => {
                            return (
                                <CsodFormFieldWraper key={index} title={field.title}>

                                    <div className={"csod-field"}>
                                        {getFormField(field)}
                                    </div>

                                    <div>
                                    <span id="ctl00_ContentPlaceHolder1_Regularexpressionvalidator1"
                                          className="error" style={{
                                        color: "Red",
                                        display: "none"
                                    }}>Invalid Email Address</span>
                                        <span id="ctl00_ContentPlaceHolder1_fromAddrRequired" className="error"
                                              style={{
                                                  color: "Red",
                                                  display: "none"
                                              }}>Required Field</span>
                                    </div>

                                </CsodFormFieldWraper>
                            );
                        })}
                    </CsodFormWraper>
                </Modal>
            </Fragment>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default FormNewTrigger;


// WEBPACK FOOTER //
// ./src/widgets/components/Forms/FormNewTrigger.js